<template>
  <div class='container medicalQuestionnaire'>
    <!-- Keyword description modal -->
    <modal v-show="modalVisible" @close="closeModal">
      <div id='keywordBody' slot='body'></div>
    </modal>
    <h3 class='textSectionTitle'>{{q2_1}}</h3>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq2' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_1a'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion2' name='medicalQuestion2' id='mq2y' aria-labelledby='lbl_mq2y' type='radio' value='true'/>
            <label id='lbl_mq2y' for='mq2y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion2' name='medicalQuestion2' id='mq2n' aria-labelledby='lbl_mq2n' type='radio' value='false'/>
            <label id='lbl_mq2n' for='mq2n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>	
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq3' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_1b'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion3' name='medicalQuestion3' id='mq3y' aria-labelledby='lbl_mq3y' type='radio' value='true'/>
            <label id='lbl_mq3y' for='mq3y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion3' name='medicalQuestion3' id='mq3n' aria-labelledby='lbl_mq3n' type='radio' value='false'/>
            <label id='lbl_mq3n' for='mq3n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq4' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_1c'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion4' name='medicalQuestion4' id='mq4y' aria-labelledby='lbl_mq4y' type='radio' value='true'/>
            <label id='lbl_mq4y' for='mq4y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion4' name='medicalQuestion4' id='mq4n' aria-labelledby='lbl_mq4n' type='radio' value='false'/>
            <label id='lbl_mq4n' for='mq4n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq5' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_1d'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion5' name='medicalQuestion5' id='mq5y' aria-labelledby='lbl_mq5y' type='radio' value='true'/>
            <label id='lbl_mq5y' for='mq5y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion5' name='medicalQuestion5' id='mq5n' aria-labelledby='lbl_mq5n' type='radio' value='false'/>
            <label id='lbl_mq5n' for='mq5n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq6' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_1e'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion6' name='medicalQuestion6' id='mq6y' aria-labelledby='lbl_mq6y' type='radio' value='true'/>
            <label id='lbl_mq6y' for='mq6y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion6' name='medicalQuestion6' id='mq6n' aria-labelledby='lbl_mq6n' type='radio' value='false'/>
            <label id='lbl_mq6n' for='mq6n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq7' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_1f'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion7' name='medicalQuestion7' id='mq7y' aria-labelledby='lbl_mq7y' type='radio' value='true'/>
            <label id='lbl_mq7y' for='mq7y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion7' name='medicalQuestion7' id='mq7n' aria-labelledby='lbl_mq7n' type='radio' value='false'/>
            <label id='lbl_mq7n' for='mq7n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <h3 class="textSectionTitle" style='margin-top:10px;'>{{q2_2}}</h3>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq8' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_2a'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion8' name='medicalQuestion8' id='mq8y' aria-labelledby='lbl_mq8y' type='radio' value='true'/>
            <label id='lbl_mq8y' for='mq8y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion8' name='medicalQuestion8' id='mq8n' aria-labelledby='lbl_mq8n' type='radio' value='false'/>
            <label id='lbl_mq8n' for='mq8n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq9' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_2b'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion9' name='medicalQuestion9' id='mq9y' aria-labelledby='lbl_mq9y' type='radio' value='true'/>
            <label id='lbl_mq9y' for='mq9y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion9' name='medicalQuestion9' id='mq9n' aria-labelledby='lbl_mq9n' type='radio' value='false'/>
            <label id='lbl_mq9n' for='mq9n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq10' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_2c'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion10' name='medicalQuestion10' id='mq10y' aria-labelledby='lbl_mq10y' type='radio' value='true'/>
            <label id='lbl_mq10y' for='mq10y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion10' name='medicalQuestion10' id='mq10n' aria-labelledby='lbl_mq10n' type='radio' value='false'/>
            <label id='lbl_mq10n' for='mq10n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq10' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;'>
          <h3 class='textSectionQuestion' v-html="q2_3"></h3>
        </legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion11' name='medicalQuestion11' id='mq11y' aria-labelledby='lbl_mq11y' type='radio' value='true'/>
            <label id='lbl_mq11y' for='mq11y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion11' name='medicalQuestion11' id='mq11n' aria-labelledby='lbl_mq11n' type='radio' value='false'/>
            <label id='lbl_mq11n' for='mq11n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
  import { addNavProceedCheck } from "../utils/navProceed.js";
  import { initKeywords } from "../utils/keywords.js";
  import modal from "../components/Modal.vue";
  import { validationRules } from "../utils/validation_rules.js";
  import { validateForm, validateField } from "../utils/validation.js";

  export default {
    components: {
      modal,
    },
    data() {
      return {
        q2_1: "1. "+this.$store.state.survey.Steps[1].Questions[0].Text,
        q2_1a: "a) "+this.$store.state.survey.Steps[1].Questions[0].SubQuestions[0].Text,
        q2_1b: "b) "+this.$store.state.survey.Steps[1].Questions[0].SubQuestions[1].Text,
        q2_1c: "c) "+this.$store.state.survey.Steps[1].Questions[0].SubQuestions[2].Text,
        q2_1d: "d) "+this.$store.state.survey.Steps[1].Questions[0].SubQuestions[3].Text,
        q2_1e: "e) "+this.$store.state.survey.Steps[1].Questions[0].SubQuestions[4].Text,
        q2_1f: "f) "+this.$store.state.survey.Steps[1].Questions[0].SubQuestions[5].Text,
        q2_2: "2. "+this.$store.state.survey.Steps[1].Questions[1].Text,
        q2_2a: "a) "+this.$store.state.survey.Steps[1].Questions[1].SubQuestions[0].Text,
        q2_2b: "b) "+this.$store.state.survey.Steps[1].Questions[1].SubQuestions[1].Text,
        q2_2c: "c) "+this.$store.state.survey.Steps[1].Questions[1].SubQuestions[2].Text,
        q2_3: "3. "+this.$store.state.survey.Steps[1].Questions[2].Text,
        modalVisible: false
      }
    },
    computed: {
      medicalQuestion2: {
        get() {
          return this.$store.state.medicalQuestion2;
        },
        set() {
          validateField(mq2y, true, validationRules());
        }
      },
      medicalQuestion3: {
        get() {
          return this.$store.state.medicalQuestion3;
        },
        set() {
          validateField(mq3y, true, validationRules());
        }
      },
      medicalQuestion4: {
        get() {
          return this.$store.state.medicalQuestion4;
        },
        set() {
          validateField(mq4y, true, validationRules());
        }
      },
      medicalQuestion5: {
        get() {
          return this.$store.state.medicalQuestion5;
        },
        set() {
          validateField(mq5y, true, validationRules());
        }
      },
      medicalQuestion6: {
        get() {
          return this.$store.state.medicalQuestion6;
        },
        set() {
          validateField(mq6y, true, validationRules());
        }
      },
      medicalQuestion7: {
        get() {
          return this.$store.state.medicalQuestion7;
        },
        set() {
          validateField(mq7y, true, validationRules());
        }
      },
      medicalQuestion8: {
        get() {
          return this.$store.state.medicalQuestion8;
        },
        set() {
          validateField(mq8y, true, validationRules());
        }
      },
      medicalQuestion9: {
        get() {
          return this.$store.state.medicalQuestion9;
        },
        set() {
          validateField(mq9y, true, validationRules());
        }
      },
      medicalQuestion10: {
        get() {
          return this.$store.state.medicalQuestion10;
        },
        set() {
          validateField(mq10y, true, validationRules());
        }
      },
      medicalQuestion11: {
        get() {
          return this.$store.state.medicalQuestion11;
        },
        set() {
          validateField(mq11y, true, validationRules());
        }
      },
    },
    methods: {
      closeModal(){
        this.modalVisible=false;
      }
    },
    mounted() {
      // If this session already has a policy number, reset the session
      if(this.$store.state.policyNumber!==""){location.reload();}

      // Focus stepTitle for accessibility.
      this.$nextTick( () => {
        document.getElementById("stepTitle").focus();
      });

      // Set listener to open keyword details
      initKeywords(this);

      // Check if Next button should be enabled or disabled.
      const targets = [
        document.getElementById("mq2y"),
        document.getElementById("mq3y"),
        document.getElementById("mq4y"),
        document.getElementById("mq5y"),
        document.getElementById("mq6y"),
        document.getElementById("mq7y"),
        document.getElementById("mq8y"),
        document.getElementById("mq9y"),
        document.getElementById("mq10y"),
        document.getElementById("mq11y")
      ];
      this.$nextTick( () => {
        addNavProceedCheck(targets);
      });
    },
  };
</script>
